import { Input, Table, TableColumnsType, Rate, Avatar } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import useRating from "hooks/useRating";
import { IRating } from "models/rating";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";

export default function Ratings() {
  const {
    activeTab,
    driverRates,
    handleDriverRateSearch,
    handlePassengerRateSearch,
    handleDriverRatePageChange,
    handlePassengerRatePageChange,
    handleTabClick,
    passengerRates,
  } = useRating();

  return (
    <div className="w-full bg-white p-5 rounded-lg shadow">
      <div className="flex justify-between mb-5">
        <div
          className={`flex-1 text-center cursor-pointer ${
            activeTab === "drivers"
              ? "font-semibold border-b-2 border-black shadow-lg"
              : ""
          }`}
          onClick={() => handleTabClick("drivers")}
        >
          Drivers
        </div>
        <div
          className={`flex-1 text-center cursor-pointer ${
            activeTab === "passengers"
              ? "font-semibold border-b-2 border-black shadow-lg"
              : ""
          }`}
          onClick={() => handleTabClick("passengers")}
        >
          Passengers
        </div>
      </div>
      <div className="tab-content">
        {activeTab === "drivers" && (
          <div>
            <div className="w-full px-6 flex justify-end items-center mb-4">
              <Input
                className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
                prefix={<SearchOutlined className="mr-2" />}
                placeholder="Search..."
                onChange={handleDriverRateSearch}
                value={driverRates.search}
              />
            </div>
            <div className="w-full mt-8 px-4">
              <Table
                loading={driverRates.loading}
                columns={columns}
                dataSource={driverRates.data}
                onChange={handleDriverRatePageChange}
                pagination={{
                  total: driverRates.total,
                  pageSize: driverRates.per_page,
                  current: driverRates.page,
                  nextIcon: (
                    <span className="flex items-center justify-center w-8 h-8 text-2xl">
                      <NextIcon />
                    </span>
                  ),
                  prevIcon: (
                    <span className="flex items-center justify-center w-8 h-8 text-2xl">
                      <PreviousIcon />
                    </span>
                  ),
                }}
              />
            </div>
          </div>
        )}
        {activeTab === "passengers" && (
          <div>
            <div className="w-full px-6 flex justify-end items-center mb-4">
              <Input
                className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
                prefix={<SearchOutlined className="mr-2" />}
                placeholder="Search..."
                onChange={handlePassengerRateSearch}
                value={passengerRates.search}
              />
            </div>
            <div className="w-full mt-8 px-4">
              <Table
                loading={passengerRates.loading}
                columns={columns}
                dataSource={passengerRates.data}
                onChange={handlePassengerRatePageChange}
                pagination={{
                  total: passengerRates.total,
                  pageSize: passengerRates.per_page,
                  current: passengerRates.page,
                  nextIcon: (
                    <span className="flex items-center justify-center w-8 h-8 text-2xl">
                      <NextIcon />
                    </span>
                  ),
                  prevIcon: (
                    <span className="flex items-center justify-center w-8 h-8 text-2xl">
                      <PreviousIcon />
                    </span>
                  ),
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const columns: TableColumnsType<IRating> = [
  {
    title: "Rater Name",
    render: (_, record) => (
      <div className="flex items-center gap-x-1">
        <Avatar shape="circle" size={40} src={record.rater.image} />
        <span>
          {record.rater.first_name} {record.rater.last_name}
        </span>
      </div>
    ),
  },
  {
    title: "Rated Name",
    render: (_, record) => (
      <div className="flex items-center gap-x-1">
        <Avatar shape="circle" size={40} src={record.rated.image} />
        <span>
          {record.rated.first_name} {record.rated.last_name}
        </span>
      </div>
    ),
  },
  {
    title: "Count",
    dataIndex: "rate",
  },
  {
    title: "Star",
    dataIndex: "rate",
    render: (star) => (
      <div className="flex items-center">
        <Rate
          disabled
          value={star}
          allowHalf
          className="custom-rate"
          style={{ fontSize: "16px" }}
        />
        <span className="ml-2">{star}</span>
      </div>
    ),
  },
  // {
  //   title: "Action",
  //   render: (text, record) => <RatingAction />,
  // },
];
